const ONE_DAY = 24 * 3600 * 1000;

export default {
  maxRow: 4,
  maxColumn: 4,
  desc: `第{{value}}周`,
  generator(start) {
    const weeks = createWeeks(start);
    
    let maxRow = this.maxRow,
      maxColumn = this.maxRow;
    const pageCount = maxRow * maxColumn;
    const maxRound = Math.ceil(weeks.length / pageCount);

    let results = [];

    for (let i = 0; i < maxRound; i++) {
      results.push(this.innerLoop(i, weeks.length, weeks));
    }
    return results;
  },

  innerLoop(page, max, weeks) {    
    let results = [],
      maxRow = this.maxRow,
      maxColumn = this.maxRow,
      desc = this.desc,
      start = page * maxRow * maxColumn;

    for (let row = 0; row < maxRow; row++) {
      let temp = [], value;

      for (let col = 0; col < maxColumn; col++) {
        value = start + row * maxColumn + col;

        if (value >= max) {
          break;
        }

        const realValue  = weeks[value];
        const [startDate, endDate] = realValue;

        temp.push({
          value: realValue,
          page: page + 1,
          row: row,
          column: col,
          inRange: false,
          start: false,
          end: false,
          text: desc.replace(/{{value}}/, value + 1),
          other: `${formatDate(startDate)}-${formatDate(endDate)}`,
          disabled: false,
          selected: false
        });
      }

      results.push(temp);
    }

    return results;
  },

  enableBtn(start, end) {
    return end - 1 > start;
  },

  enablePageBtn(leftDate, rightDate, leftPage, rightPage) {
    return true;
  },

  leftDate(year) {
    return year;
  },

  rightDate(start, end) {
    return start === end ? start + 1 : end;
  },

  // displayFormatter(date) {
  //   try {
  //     if (!date) return null;
  //
  //     date = new Date(date);
  //     const year = date.getFullYear();
  //
  //     const { week } = getWeekNumber(date);
  //
  //     return `${year}年第${week}周`;
  //   } catch (err) {
  //     throw new Error(err);
  //   }
  // },

  displayFormatter(date,isRangeStart = true) {
    try {
      let start,end,startTime,endTime;
      
      if (isRangeStart) {
        start = new Date(date);
        startTime = +start;
        endTime = startTime + 6 * ONE_DAY;
        end = new Date(endTime);        
      } 
      else {
        end = new Date(date);
        endTime = +end;
        startTime = endTime - 6 * ONE_DAY;
        start = new Date(startTime);
      }

      return `${formatDate(startTime)}-${formatDate(endTime)}`;
    } catch (err) {
      throw new Error(err);
    }
  },

  displayLabelFormatter(year) {
    return `${year}年`;
  },

  valueFormatter({ value }, isStart) {
    if (!value) {
      return "";
    }
    
    const [ startDate, endDate ] = value;

    return `${formatDate(isStart ? startDate : endDate, "-", true)}`;
  },
  
  change(isPrev) {
    return (isPrev ? -1 : 1) ;
  },

  pageChange(isPrev) {
    return (isPrev ? -1 : 1) ;
  },

  dateToPos(date) {
    date = new Date(date);
    const year = date.getFullYear();
    
    const { week, range } = getWeekNumber(date);
    const onePageCount = this.maxColumn * this.maxRow;

    const page = Math.ceil(week / onePageCount);
    const onePageRemain = onePageCount + week - page * onePageCount;

    let row = Math.ceil(onePageRemain / this.maxColumn);
    let column = this.maxColumn + onePageRemain - row * this.maxColumn;

    if (onePageRemain === 0) {
      row = this.maxRow;
      column = this.maxColumn;
    }    

    return {
      column: column - 1,
      row: row - 1,
      page,
      value: range,
      year
    };
  }
};

function formatDate(mill, separator = ".", whole = false) {
  var y = new Date(mill);

  return whole 
    ? `${y.getFullYear()}${separator}${formatDig(y.getMonth() + 1)}${separator}${formatDig(y.getDate())}`
    :`${formatDig(y.getMonth() + 1)}${separator}${formatDig(y.getDate())}`;
}

function formatDig(num) {
  return num > 9 ? "" + num : "0" + num;
}

function createWeeks(year) {
  let res = [];

  let start = new Date(year, 0, getFirstDayInYear(year)),
    end = new Date(year + 1, 0, getFirstDayInYear(year + 1) - 1);
    
  const endDate = end.getTime();

  let startTime = start.getTime();
  let endTime = startTime + 6 * ONE_DAY;

  while (endTime <= endDate) {
    res.push([startTime, endTime]);

    startTime = endTime + ONE_DAY;
    endTime = endTime + 7 * ONE_DAY;
  }

  return res;
}

function getFirstDayInYear(year) {
  let start = new Date(year, 0, 1);
  //每年1月1号的星期几
  let startDay = start.getDay();

  //每一年的一号为这一年的第一周，因此这一周的第一天为1号减这一号的星期几 + 1天
  return 1 - startDay + 1;
}

function getWeekNumber(targetDay) {  
  var year = targetDay.getFullYear();
  var month = targetDay.getMonth();
  var days = targetDay.getDate();

  let start = new Date(year, 0, 1),
    end = new Date(year, month, days);

  start = new Date(year, 0, getFirstDayInYear(year));

  let startTime = +start;
  let endTime = startTime + 6 * ONE_DAY;
  
  let week = 0;

  while (endTime < end) {
    week++;
    startTime = endTime + ONE_DAY;
    endTime = endTime + 7 * ONE_DAY;
  }

  week++;
  
  return {
    week,
    range: [startTime, endTime]
  };
}